import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

/**
 * Invisible forensic watermark: the member's private 7-letter code tiled across
 * the frame at ~0.6% strength. Invisible to the eye; Admin → Security → Leak check
 * boosts a leaked screenshot until the code reads clearly.
 */
let cached = null;
const ALPHA = 0.006;

const tile = (code) => {
  const t = `PMS ${code}`;
  const txt = (fill, dx) => `<text x="${14 + dx}" y="${62 + dx}" fill="${fill}" fill-opacity="${ALPHA}">${t}</text><text x="${262 + dx}" y="${165 + dx}" fill="${fill}" fill-opacity="${ALPHA}">${t}</text>`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="520" height="200"><g font-family="monospace" font-size="30" font-weight="900" letter-spacing="4" transform="rotate(-12 260 100)">${txt("#fff", 0)}${txt("#000", 1)}</g></svg>`;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
};

export default function Watermark({ children, fullscreen = false }) {
  const { user } = useAuth();
  const [code, setCode] = useState(cached);

  useEffect(() => {
    if (!user || cached) return;
    api.get("/watermark/code").then((r) => { cached = r.data.code; setCode(cached); }).catch(() => {});
  }, [user]);

  if (!user || !code) return <>{children}</>;

  const layer = (
    <div
      data-testid="watermark-tag"
      aria-hidden="true"
      className={fullscreen ? "fixed inset-0 z-[45] pointer-events-none" : "absolute inset-0 pointer-events-none z-10"}
      style={{ backgroundImage: tile(code), backgroundRepeat: "repeat" }}
    />
  );

  if (fullscreen) return <>{children}{layer}</>;
  return (
    <div className="relative h-full">
      {children}
      {layer}
    </div>
  );
}
